import { useCallback, useEffect, useState } from "react";

const useReorder = ({ items, onSave }: { items: Array<any>; onSave: (data: any) => void }) => {
  const [reorderedItems, setReorderedItems] = useState([...items]);
  const [isReordering, setIsReordering] = useState<boolean>(false);

  useEffect(() => {
    setReorderedItems([...items]);
  }, [items]);

  const toggleIsReordering = useCallback(() => {
    setIsReordering((p) => !p);
  }, []);

  useEffect(() => {
    console.log("items")
  }, [items])
 
  useEffect(() => {
    console.log("onSave")
  }, [onSave])
 
  const onReorderEnd = useCallback(({ oldIndex, newIndex }) => {
    setReorderedItems((prev) => {
      const temp = [...prev].filter((i) => i !== prev[oldIndex]);
      temp.splice(newIndex, 0, prev[oldIndex]);
      return temp;
    });
  }, []);

  const saveOrdering = useCallback(async () => {
    const newOrderData = reorderedItems.map((item, index) => ({
      order_index: index,
      id: item.id,
    }));
    console.log("saving...");

    onSave(JSON.stringify(newOrderData));
  }, [reorderedItems, onSave]);

  return { isReordering, toggleIsReordering, reorderedItems, onReorderEnd, saveOrdering };
};

export default useReorder;
